<app-auth-navbar></app-auth-navbar>

<main class="rtl">
  <div class="relative pt-16 pb-32 flex content-center items-center justify-center">
    <div class="bg-primary absolute top-0 w-full h-500-px bg-center bg-cover">
      <span class="w-full h-full absolute" id="blackOverlay"></span>
    </div>
    <div class="container relative mx-auto pt-32">
      <div class="items-center flex flex-wrap">
        <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
          <div class="">
            <h1 class="text-white font-semibold text-5xl leading-normal">
              مجله سلامت
            </h1>
            <div class="relative flex w-full flex-wrap items-stretch mt-12"><span
                class="z-10 h-full leading-snug font-normal text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"><i
                  class="fa fa-search"></i></span><input type="text" placeholder=" نام پزشک، نام بیماری، تخصص ... "
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded shadow  w-full pl-10">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="py-16 main-bg">
    <div class="container mx-auto p-4">
      <div class="flex flex-wrap justify-center text-center mb-4">
        <div class="w-full lg:w-6/12 p-4">
          <h3 class="text-4xl font-semibold"> مجله سلامت </h3>
          
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
            <img alt="..." src="assets/img/blog-test.png" class="shadow-lg w-full" />
            <div class="pt-6">
              <h5 class="font-bold"> اختلال دو قطبی چیست؟ راه های شناسایی آن؟  </h5>
              <p class="my-2 text-sm text-blueGray-400 uppercase font-semibold">
                 نویسنده: دکتر اکبر زارع
              </p>
              <p class="mt-1 text-sm">
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
              </p>
              <div class="mt-6 flex justify-between">
                <button class="bg-primary text-white w-full h-8 rounded-sm outline-none focus:outline-none mb-1" type="button"> 
                  ادامه مطلب
                </button>       
              </div>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
            <img alt="..." src="assets/img/blog-test.png" class="shadow-lg w-full" />
            <div class="pt-6">
              <h5 class="font-bold"> اختلال دو قطبی چیست؟ راه های شناسایی آن؟  </h5>
              <p class="my-2 text-sm text-blueGray-400 uppercase font-semibold">
                 نویسنده: دکتر اکبر زارع
              </p>
              <p class="mt-1 text-sm">
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
              </p>
              <div class="mt-6 flex justify-between">
                <button class="bg-primary text-white w-full h-8 rounded-sm outline-none focus:outline-none mb-1" type="button"> 
                  ادامه مطلب
                </button>       
              </div>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
            <img alt="..." src="assets/img/blog-test.png" class="shadow-lg w-full" />
            <div class="pt-6">
              <h5 class="font-bold"> اختلال دو قطبی چیست؟ راه های شناسایی آن؟  </h5>
              <p class="my-2 text-sm text-blueGray-400 uppercase font-semibold">
                 نویسنده: دکتر اکبر زارع
              </p>
              <p class="mt-1 text-sm">
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
              </p>
              <div class="mt-6 flex justify-between">
                <button class="bg-primary text-white w-full h-8 rounded-sm outline-none focus:outline-none mb-1" type="button"> 
                  ادامه مطلب
                </button>       
              </div>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-6/12 xl:w-4/12 p-4">
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
            <img alt="..." src="assets/img/blog-test.png" class="shadow-lg w-full" />
            <div class="pt-6">
              <h5 class="font-bold"> اختلال دو قطبی چیست؟ راه های شناسایی آن؟  </h5>
              <p class="my-2 text-sm text-blueGray-400 uppercase font-semibold">
                 نویسنده: دکتر اکبر زارع
              </p>
              <p class="mt-1 text-sm">
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
              </p>
              <div class="mt-6 flex justify-between">
                <button class="bg-primary text-white w-full h-8 rounded-sm outline-none focus:outline-none mb-1" type="button"> 
                  ادامه مطلب
                </button>       
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
</main>
<app-footer></app-footer>